import s from './HeroCrumbs.module.scss';

// [2026-09-11 사용자] 히어로 상단 브레드크럼 — 커스텀 히어로 페이지에서 SubPageHero와 동일한 '현재 위치' 표기를 통일.
//   items 예: ['HOME','제품'] · ['HOME','도입사례']. 마지막=현재(딤). 링크는 데모 차단(href#) — 헤더 네비로 이동.
export default function HeroCrumbs({ items }: { items: string[] }) {
	if (!items || items.length === 0) return null;
	return (
		<nav className={s.bar} aria-label="현재 위치">
			{items.map((c, i) => {
				const isCurrent = i === items.length - 1;
				return (
					<span key={c + i} className={s.item}>
						{i > 0 && <span className={s.sep} aria-hidden>›</span>}
						{isCurrent
							? <span className={s.current} aria-current="page">{c}</span>
							: <a href="#" className={s.link} onClick={(e) => e.preventDefault()}>{c}</a>}
					</span>
				);
			})}
		</nav>
	);
}
